import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Image, Stack, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";
import { HighlightedBlock, HighlightedBlockHeading } from "../utils/HighlightedBlock";
import { PageTitle } from "../utils/PageTitle";

export function Courses() {
    const { t } = useTranslation();
    const location = useLocation();

    return (
        <Box>
            <Box position="relative" w="100%">
                <Image
                    src="/images/headings/heading-electro.jpg"
                    alt="heading-about"
                    w="100%"
                    h={{ base: 36, sm: 36, md: 56, lg: 72 }}
                    objectFit="cover"
                    objectPosition={"center center"}
                    shadow={"md"}
                />

                {/* original top={7} */}
                <Breadcrumb position="absolute" top={7} left={10} color={"white"}>
                    <BreadcrumbItem>
                        <BreadcrumbLink href="/">Garrigue Games</BreadcrumbLink>
                    </BreadcrumbItem>

                    <BreadcrumbItem fontWeight={"semibold"} isCurrentPage>
                        <BreadcrumbLink href="/courses">{t("menuButtons.courses")}</BreadcrumbLink>
                    </BreadcrumbItem>
                </Breadcrumb>
            </Box>

            <VStack maxW={1536} p={10} alignItems={"left"}>
                <PageTitle>{t("courses.title")}</PageTitle>
                <Text marginBottom={5} fontSize="md">
                    {t("courses.paragraph1")}
                </Text>
                <Stack direction="column" gap={"20px"}>
                    <HighlightedBlock>
                        <Link to="https://is.muni.cz/predmet/fi/PV255" target="_blank" rel="noopener noreferrer">
                            <Stack direction="column">
                                <HighlightedBlockHeading>FI:PV255 Game Development I</HighlightedBlockHeading>

                                <Text>
                                    The aim of the course is to introduce the field of development of digital games, in
                                    both theoretical and practical approaches. Lectures will provide theoretical
                                    principles of game development (computer graphics, physics, games interfaces, etc.).
                                    At seminars, students will get experience with the development of digital games
                                    through work on individual and later team-based projects.
                                </Text>
                            </Stack>
                        </Link>
                    </HighlightedBlock>
                    <HighlightedBlock>
                        <Link to="https://is.muni.cz/predmet/fi/PV266" target="_blank" rel="noopener noreferrer">
                            <Stack direction="column">
                                <HighlightedBlockHeading>FI:PV266 Game Development II</HighlightedBlockHeading>

                                <Text>
                                    The goal of the course is to provide more experience with the development of digital
                                    games. Students will continue the development of games prototyped in PV255 Game
                                    Development I with the goal to create a final game by the end of the course. By
                                    working on a team project and guidance of lecturers, students will get more
                                    experience with all digital game production phases: preproduction and planning;
                                    production; testing; release and presentation of the game The main output of the
                                    course - digital game - should also serve as an important item in students'
                                    professional portfolio.
                                </Text>
                            </Stack>
                        </Link>
                    </HighlightedBlock>
                    <HighlightedBlock>
                        <Link to="https://is.muni.cz/predmet/fi/PA215" target="_blank" rel="noopener noreferrer">
                            <Stack direction="column">
                                <HighlightedBlockHeading>FI:PA215 Game Design I</HighlightedBlockHeading>

                                <Text>
                                    The aim of the Game Design I. course is to (a) develop the ability to critically
                                    analyze digital and board game rules and structure and (b) to teach students
                                    practical methods of rapid paper prototyping of gaming systems. These two building
                                    blocks support the main objective of the course which is (c) to improve students
                                    skill in designing games.
                                </Text>
                            </Stack>
                        </Link>
                    </HighlightedBlock>
                    <HighlightedBlock>
                        <Link to="https://is.muni.cz/predmet/fi/PA216" target="_blank" rel="noopener noreferrer">
                            <Stack direction="column">
                                <HighlightedBlockHeading>FI:PA216 Game Design II</HighlightedBlockHeading>

                                <Text>
                                    The aim of Game Design II. is to (a) enhance the knowledge and applied the use of
                                    (digital) games language, (b) analyze complex design techniques and specific
                                    features of digital games, and (c) develop the ability to connect individual
                                    elements of (digital) games to interrelated dependencies. The main objective of the
                                    course is (d) to train and develop students skills in designing games.
                                </Text>
                            </Stack>
                        </Link>
                    </HighlightedBlock>
                    <HighlightedBlock>
                        <Link to={location.pathname + "/dungeon"} target="_self" rel="noopener noreferrer">
                            <Stack direction="column">
                                <HighlightedBlockHeading>FI:VV078 Game Development Dungeon</HighlightedBlockHeading>
                                <Text>{t("dungeon.paragraph1")}</Text>
                            </Stack>
                        </Link>
                    </HighlightedBlock>
                </Stack>
            </VStack>
        </Box>
    );
}

export default Courses;
